import axiosInstance from "../../apiAxios/axiosInstance";

// Category List
export const ProductList = async(payload) => {
const response=  await axiosInstance.post("/admin/product-list",payload);
return response.data
};
export const ActiveProductList = async(payload) => {
const response=  await axiosInstance.post("/admin/active-product-list",payload);
return response.data
};
export const CityList = async(payload) => {
const response=  await axiosInstance.post("/admin/city-list",payload);
return response.data
};
export const StateList = async(payload) => {
const response=  await axiosInstance.post("/admin/state-list",payload);
return response.data
};

// Create
export const AddProduct = async(payload) => {
  return axiosInstance.post("/admin/product-store", payload);
};

// Show
export const ViewProductDetail = async(payload) => {
  return axiosInstance.post("/admin/product-show", payload);
};

export const UpdateProduct = async(payload) => {
  return axiosInstance.post("/admin/product-update", payload);
};

// Delete
// export const DeleteProduct = (payload) => {
//   return axiosInstance.post("/admin/product-delete", payload);
// };

export const DeleteProduct = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/product-delete",
    payload
  );
  return response.data;
};

export const ProductChangeStatus = (payload) => {
  return axiosInstance.post("/admin/product-status-update", payload);
};